import { render, staticRenderFns } from "./groupManagement.vue?vue&type=template&id=5426a094"
import script from "./groupManagement.vue?vue&type=script&lang=js"
export * from "./groupManagement.vue?vue&type=script&lang=js"
import style0 from "./groupManagement.vue?vue&type=style&index=0&id=5426a094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports